<app-spinner></app-spinner>
<div class="container-fluid" [hidden]="dashPrevFlag">
    <div class="row py-1">
        <div class="col-12">
            <h3 class="dashboard">Dashboard</h3>
        </div>
    </div>
    <div class="row px-2">
        <div class="col-12">
            <mat-card appearance="outlined" class="py-2 card">
                <mat-card-header class="total-complaint-registered">
                    <mat-card-title>Total Complaint Registered</mat-card-title>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                        <path d="M3 12.5H7V21.5H3V12.5ZM17 8.5H21V21.5H17V8.5ZM10 2.5H14V21.5H10V2.5Z" fill="#7A7FA1" />
                    </svg>
                </mat-card-header>
                <mat-card-content>
                    <span class="fifty">{{total_complaints}}</span>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="row px-3 my-4">
        <div class="col-12 add-Complaint">
            <button class="hover-light" style="background-color: #226CE0; color: white;" mat-raised-button
                routerLink="/sdp/operator/new-compliants"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="17"
                    viewBox="0 0 16 17" fill="none">
                    <path d="M8.00065 3.83301V13.1663M3.33398 8.49967H12.6673" stroke="#F5F5F5" stroke-width="1.6"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg><span class="pl-2">Add New Complaints</span></button>
        </div>
    </div>

    <div class="row px-4" class="shadow-wrapper">
        <div class="col-12">
            <h3 class="recent-com">Recent Complaints</h3>
            <div style="overflow-x: auto;">
                <input type="text" class="form-control fontAwesome mb-2"
                    style="padding: 8px; margin-bottom: 10px; width: 100%;"
                    (keyup)="applyFilter($any($event.target).value)" placeholder="Search">
                <table mat-table [dataSource]="complaints" class="mat-elevation-z8" style="width: 100%;">

                    <!-- ID Column -->
                    <ng-container matColumnDef="sno">
                        <th mat-header-cell *matHeaderCellDef>Sr. No.</th>
                        <td mat-cell *matCellDef="let element ; let i=index">{{ complaints['filteredData'].length-i }}
                        </td>
                    </ng-container>
                    <!-- ID Column -->
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef>Ticket Id</th>
                        <td mat-cell *matCellDef="let element">{{ element.ticket_id }}</td>
                    </ng-container>



                    <!-- Department Column -->
                    <!-- <ng-container matColumnDef="dept">
                        <th mat-header-cell *matHeaderCellDef>Department</th>
                        <td mat-cell *matCellDef="let element">{{ element.departments }}</td>
                    </ng-container> -->


                    <!-- Zone Column -->
                    <ng-container matColumnDef="zone">
                        <th mat-header-cell *matHeaderCellDef>Zone</th>
                        <td mat-cell *matCellDef="let element">{{ element.zone }}</td>
                    </ng-container>


                    <!-- Ward Column -->
                    <ng-container matColumnDef="ward">
                        <th mat-header-cell *matHeaderCellDef>Ward</th>
                        <td mat-cell *matCellDef="let element">{{ element.ward }}</td>
                    </ng-container>

                    <!-- Created Column -->
                    <ng-container matColumnDef="created">
                        <th mat-header-cell *matHeaderCellDef>Create date</th>
                        <td mat-cell *matCellDef="let element" class="created">{{ element.create_date }}</td>
                    </ng-container>

                    <!-- Days Open Column -->
                    <ng-container matColumnDef="days_Open">
                        <th mat-header-cell *matHeaderCellDef>Days Open</th>
                        <td mat-cell *matCellDef="let element" class="center1">{{ element.number_of_open_days }}</td>
                    </ng-container>


                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="center1">Action</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <div class="d-flex justify-content-center align-items-center">
                                <h6 style="color: rgb(0, 26, 255); text-decoration: underline; cursor: pointer;"
                                    class="mt-2 view" (click)="route(element)" matTooltip="View detailed information">
                                    View More
                                </h6>


                               <mat-icon
                                    style="cursor: pointer; vertical-align: middle; margin-left: 10px; color: rgb(0, 26, 255);"
                                    class="more-options-icon" [matMenuTriggerFor]="menu" matTooltip="More options">
                                    &#8942;
                                </mat-icon>
                            </div>


                            <mat-menu #menu="matMenu">

                                <h6 mat-menu-item (click)="onDownloadPDF(element)">
                                    <span
                                        style="color: rgb(1, 159, 244); text-decoration: underline;cursor: pointer; font-size: 14px;">Print
                                        Form</span>
                                </h6>
                            </mat-menu>
                        </td>
                    </ng-container>


                    <!-- Table Headers and Rows -->
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                </table>
            </div>
        </div>
        <mat-paginator #paginator [pageSizeOptions]="[3,10, 20,50,75,100]" showFirstLastButtons></mat-paginator>
    </div>
</div>
<!-- </div> -->

<!-- <div class="container-fluid" [hidden]="dashFilePrevFlag">
<div class="row px-4" class="shadow-wrapper">
 <div class="row py-1">
        <div class="col-12">
            <h3 class="dashboard">Ticket Id : {{prevViewFileObj['ticket_id']}}</h3>
        </div>
    </div>
 <div class="row py-1 mb-3">
        <div class="col-12 d-flex justify-content-end">
            <h3 class="dashboard" style="color: rgb(0, 255, 128); text-decoration: underline;cursor: pointer;" (click)="back()">  < &nbsp; Back </h3>
        </div>
    </div>

 <div class="row py-1 mb-3">
        <div class="col-12 d-flex justify-content-end align-items-center">
            <h6> Status : {{prevViewFileObj['status']}}</h6> 
        </div>
</div>
 <div class="row py-1 mb-3">
        <div class="col-2">
            <h6> Fill Name</h6> 
        </div>
        <div class="col-1">
            <h6>:</h6> 
        </div>
        <div class="col-3">
             {{prevViewFileObj['full_name']}}
        </div>
        <div class="col-2">
            <h6> Mobile No.</h6> 
        </div>
        <div class="col-1">
            <h6>:</h6> 
        </div>
        <div class="col-3">
             {{prevViewFileObj['mobile_no']}}
        </div>
</div>
 <div class="row py-1 mb-3">
        <div class="col-2">
            <h6>Complaint Department</h6> 
        </div>
        <div class="col-1">
            <h6>:</h6> 
        </div>
        <div class="col-9">
             {{prevViewFileObj['departments']}}
        </div>
</div>
 <div class="row py-1">
        <div class="col-12">
            <h6>Complaint Description</h6> 
        </div>
</div>
 <div class="row py-1 mb-3">
        <div class="col-12">
             {{prevViewFileObj['complaint_desc']}}
        </div>
</div>

 <div class="row py-1 mb-3">
        <div class="col-2">
            <h6>Zone</h6> 
        </div>
        <div class="col-1">
            <h6>:</h6> 
        </div>
        <div class="col-3">
             {{prevViewFileObj['zone']}}
        </div>
        <div class="col-2">
            <h6> Ward</h6> 
        </div>
        <div class="col-1">
            <h6>:</h6> 
        </div>
        <div class="col-3">
             {{prevViewFileObj['ward']}}
        </div>
</div>
 <div class="row py-1 mb-3">
        <div class="col-2">
            <h6>mohalla</h6> 
        </div>
        <div class="col-1">
            <h6>:</h6> 
        </div>
        <div class="col-3">
             {{prevViewFileObj['mohalla']}}
        </div>
        <div class="col-2">
            <h6> Uploaded Document</h6> 
        </div>
        <div class="col-1">
            <h6>:</h6> 
        </div>
        <div class="col-3">
             <div *ngIf="prevViewFileObj['com_doc'] ; else elseBlock" (click)="viewDoc(prevViewFileObj,'com_doc','com')">{{prevViewFileObj['com_doc']}}</div>
             <ng-template #elseBlock>
                N/A
             </ng-template>
        </div>
    </div>
 <div class="row py-1 mb-3">
        <div class="col-2">
            <h6>Other Document</h6> 
        </div>
        <div class="col-1">
            <h6>:</h6> 
        </div>
       <div class="col-9">
             <div *ngIf="prevViewFileObj['others_doc'] ; else elseBlock" (click)="viewDoc(prevViewFileObj,'others_doc','others')">{{prevViewFileObj['others_doc']}}</div>
             <ng-template #elseBlock>
                N/A
             </ng-template>
        </div>
      
    </div>


 <div class="row py-1 mb-3" *ngIf="prevViewFileObj['is_instant_resolved']">

        <div class="col-12 mb-3">
            <h5 class="heading">Instant Resolution Status</h5> 
        </div>

          <div class="col-2 mb-3">
            <h6>Uploaded Document</h6> 
        </div>
        <div class="col-1 mb-3">
            <h6>:</h6> 
        </div>
       <div class="col-9 mb-3">
             <div *ngIf="prevViewFileObj['resolved_doc'] ; else elseBlock" (click)="viewDoc(prevViewFileObj,'resolved_doc','resolved')">{{prevViewFileObj['resolved_doc']}}</div>
             <ng-template #elseBlock>
                N/A
             </ng-template>
        </div>

        
        <div class="col-12">
            <h6>Remark</h6> 
        </div>
       <div class="col-12 mb-3 ">
             <div >{{prevViewFileObj['resolved_remark']}}</div>
        </div>
       
        
        <div class="col-12" >
            <h6>Approval Description</h6> 
        </div>
       <div class="col-12 mb-3 "> 
             <div>{{prevViewFileObj['resolved_desc']}}</div>
        </div>
    </div>

 <div class="row py-1 mb-3">
          <div class="col-12 mb-2">
            <h5 class="heading">Others Details</h5> 
        </div>

       <div class="col-2">
            <h6>Registered by</h6> 
        </div>
       <div class="col-1">
            :
        </div>
       <div class="col-3">
            {{prevViewFileObj['create_user_id']}}
        </div>
     </div>
</div>

 
 

</div>
  -->